import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import { uploadFile } from "shared-utility/store/utils/fileHelper";
import {
  defaultReturn
  , multipleObjectReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
  , subKeySaga
  , fillDictionary
} from "shared-utility/store/utils/helpers";

// ACTIONS
export const DEAL_SETTINGS_GET = generateDefaultActions("DEAL_SETTINGS_GET");
export const dealGet = payload => makePayload(DEAL_SETTINGS_GET.value, payload);
function* dealGetSaga(payload) {
  const url = `/deals/${payload.dealId}`;
  yield requestSaga(DEAL_SETTINGS_GET, url, "GET");
}

export const DEAL_SETTINGS_GET_ALERTS = generateDefaultActions("DEAL_SETTINGS_GET_ALERTS");
export const dealGetAlerts = payload => makePayload(DEAL_SETTINGS_GET_ALERTS.value, payload);
function* dealGetAlertsSaga(payload) {
  const url = "/getAlertsForDeal";
  yield requestSaga(DEAL_SETTINGS_GET_ALERTS, url, "POST", payload);
}

export const DEAL_SETTINGS_GET_W_SUBKEY = generateDefaultActions("CLEAR_DEAL_SETTINGS");
export const dealGetWithSubkey = payload => makePayload(DEAL_SETTINGS_GET_W_SUBKEY.value, payload);
function* dealGetWithSubkeySaga(payload) {
  const url = `/deals/${payload.dealId}`;
  const requestSaga = subKeySaga(payload.dealId);
  yield requestSaga(DEAL_SETTINGS_GET_W_SUBKEY, url, "GET");
}

export const DEAL_SETTINGS_CANCEL_REFINANCE = generateDefaultActions("DEAL_SETTINGS_CANCEL_REFINANCE");
export const cancelDealRefinance = payload => makePayload(DEAL_SETTINGS_CANCEL_REFINANCE.value, payload);
function* cancelDealRefinanceSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;
  const url = "/deal/cancelDealRefinance";
  yield requestSaga(DEAL_SETTINGS_CANCEL_REFINANCE, url, "POST", payload);
  if (callback) {
    callback();
  }
}

export const DEAL_SETTINGS_REVIVE_DEAL = generateDefaultActions("DEAL_SETTINGS_REVIVE_DEAL");
export const reviveDeal = payload => makePayload(DEAL_SETTINGS_REVIVE_DEAL.value, payload);
function* reviveDealSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;
  const url = "/deal/reviveDeal";
  yield requestSaga(DEAL_SETTINGS_REVIVE_DEAL, url, "POST", payload);
  if (callback) {
    callback();
  }
}

export const DEAL_SETTINGS_KILL_DEAL = generateDefaultActions("DEAL_SETTINGS_KILL_DEAL");
export const killDeal = payload => makePayload(DEAL_SETTINGS_KILL_DEAL.value, payload);
function* killDealSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;
  const url = "/deal/killDeal";
  yield requestSaga(DEAL_SETTINGS_KILL_DEAL, url, "POST", payload);
  if (callback) {
    callback();
  }
}

export const DEAL_SETTINGS_CHANGE_STAGE = generateDefaultActions("DEAL_SETTINGS_CHANGE_STAGE");
export const changeDealStage = payload => makePayload(DEAL_SETTINGS_CHANGE_STAGE.value, payload);
function* changeDealStageSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;
  const url = "/deal/changeDealStage";
  yield requestSaga(DEAL_SETTINGS_CHANGE_STAGE, url, "POST", payload);
  if (callback) {
    callback();
  }
}

export const DEAL_SETTINGS_GET_WINNING_QUOTES = generateDefaultActions("DEAL_SETTINGS_GET_WINNING_QUOTES");
export const getWinningQuotes = payload => makePayload(DEAL_SETTINGS_GET_WINNING_QUOTES.value, payload);
function* getWinningQuotesSaga(payload) {
  const url = `/getWinningQuotes/${payload.dealId}`;
  yield requestSaga(DEAL_SETTINGS_GET_WINNING_QUOTES, url, "GET");
}

export const DEAL_SETTINGS_CLOSE_DEAL = generateDefaultActions("DEAL_SETTINGS_CLOSE_DEAL");
export const closeDeal = payload => makePayload(DEAL_SETTINGS_CLOSE_DEAL.value, payload);
function* closeDealSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;
  const url = `/deal/${payload.dealId}/close`;
  yield requestSaga(DEAL_SETTINGS_CHANGE_STAGE, url, "POST", payload);
  if (callback) {
    callback();
  }
}

// START ATTACHMENTS

export const dealGetAttachments = payload => makePayload(DEAL_SETTINGS_GET_ATTACHMENTS.value, payload);
export const DEAL_SETTINGS_GET_ATTACHMENTS = generateDefaultActions("DEAL_SETTINGS_GET_ATTACHMENTS");
function* dealGetAttachmentsSaga(payload) {
  const url = "/getFiles/byModel";
  yield requestSaga(DEAL_SETTINGS_GET_ATTACHMENTS, url, "POST", { modelName: "deal", modelId: payload.dealId });
}

export const DEAL_SETTINGS_PUT_ATTACHMENT = generateDefaultActions("DEAL_SETTINGS_PUT_ATTACHMENT");
export const dealPutAttachment = payload => makePayload(DEAL_SETTINGS_PUT_ATTACHMENT.value, payload);
function* dealPutAttachmentSaga(payload) {
  const url = "/files";
  payload = {
    ...payload,
    id: payload.file.id,
    isPrivate: payload.file.isPrivate,
    model: "deal",
    modelId: payload.dealId,
    url: "/files"
  };

  yield requestSaga(DEAL_SETTINGS_PUT_ATTACHMENT, url, "PUT", payload);
  yield put(dealGetAttachments({ dealId: payload.dealId }));
}

export const DEAL_SETTINGS_POST_ATTACHMENT = generateDefaultActions("DEAL_SETTINGS_POST_ATTACHMENT");
export const dealPostAttachment = payload => makePayload(DEAL_SETTINGS_POST_ATTACHMENT.value, payload);
function* dealPostAttachmentSaga(payload) {
  const callback = handleCallback(payload);
  payload = {
    ...payload,
    model: "deal",
    modelId: payload.dealId,
    url: "/files"
  };

  yield call(uploadFile, payload);
  yield put(DEAL_SETTINGS_POST_ATTACHMENT.createSuccess());
  yield put(dealGetAttachments({ dealId: payload.dealId }));
  yield callback();
}

export const DEAL_SETTINGS_DELETE_ATTACHMENT = generateDefaultActions("DEAL_SETTINGS_DELETE_ATTACHMENT");
export const dealDeleteAttachment = payload => makePayload(DEAL_SETTINGS_DELETE_ATTACHMENT.value, payload);
function* dealDeleteAttachmentSaga(payload) {
  const url = `/files/${payload.fileId}`;
  const callback = handleCallback(payload);

  yield requestSaga(DEAL_SETTINGS_DELETE_ATTACHMENT, url, "DELETE", payload);
  yield put(dealGetAttachments({ dealId: payload.dealId }));
  yield callback();
}

// END ATTACHMENTS

// START NOTES

export const DEAL_SETTINGS_GET_NOTES = generateDefaultActions("DEAL_SETTINGS_GET_NOTES");
export const dealGetNotes = payload => makePayload(DEAL_SETTINGS_GET_NOTES.value, payload);
function* dealGetNotesSaga(payload) {
  const url = `/deals/notes/${payload.dealId}`;
  yield requestSaga(DEAL_SETTINGS_GET_NOTES, url, "GET");
}

export const DEAL_SETTINGS_PUT_NOTE = generateDefaultActions("DEAL_SETTINGS_PUT_NOTE");
export const dealPutNote = payload => makePayload(DEAL_SETTINGS_PUT_NOTE.value, payload);
function* dealPutNoteSaga(payload) {
  const url = `/notes/${payload.note.id}`;
  yield requestSaga(DEAL_SETTINGS_PUT_NOTE, url, "PUT", payload);
  yield put(dealGetNotes({ dealId: payload.dealId }));
}

export const DEAL_SETTINGS_POST_NOTE = generateDefaultActions("DEAL_SETTINGS_POST_NOTE");
export const dealPostNote = payload => makePayload(DEAL_SETTINGS_POST_NOTE.value, payload);
function* dealPostNoteSaga(payload) {
  const url = "/deal/addnote";
  const note = {
    model: "deal",
    modelId: payload.dealId,
    note: payload.note,
    pinned: false
  };
  yield requestSaga(DEAL_SETTINGS_POST_NOTE, url, "POST", { note });
  yield put(dealGetNotes({ dealId: payload.dealId }));
}

export const DEAL_SETTINGS_DELETE_NOTE = generateDefaultActions("DEAL_SETTINGS_DELETE_NOTE");
export const dealDeleteNote = payload => makePayload(DEAL_SETTINGS_DELETE_NOTE.value, payload);
function* dealDeleteNoteSaga(payload) {
  const url = `/notes/${payload.noteId}`;
  yield requestSaga(DEAL_SETTINGS_DELETE_NOTE, url, "DELETE");
  yield put(dealGetNotes({ dealId: payload.dealId }));
}

export const DEAL_SETTINGS_CANCEL_MODIFY_LOANS = generateDefaultActions("DEAL_SETTINGS_CANCEL_MODIFY_LOANS");
export const cancelModifyLoans = dealId => makePayload(DEAL_SETTINGS_CANCEL_MODIFY_LOANS.value, { dealId });
function* cancelModifyLoansSaga(payload) {
  yield requestSaga(DEAL_SETTINGS_CANCEL_MODIFY_LOANS, `/deal/${payload.dealId}/cancelModifyLoans`, "POST", payload);
}
// END NOTES

export const DEAL_SETTINGS_UPDATE_DETAILS = generateDefaultActions("DEAL_SETTINGS_UPDATE_DETAILS");
export const updateDeal = payload => makePayload(DEAL_SETTINGS_UPDATE_DETAILS.value, { payload });
function* updateDealSaga(payload) {
  const callback = handleCallback(payload);
  const deal = payload.payload.deal;
  yield requestSaga(DEAL_SETTINGS_UPDATE_DETAILS, `/deals/${payload.payload.id}`, "PUT", { deal: payload.payload.deal });
  yield callback();
}

// REDUCER

const initialState = {
  deal: null,
  notes: [],
  alerts: [],
  attachments: []
};

export function dealSettingsReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    // DEAL

    case DEAL_SETTINGS_GET.error:
      ToastError("Data Fetch Unsuccessful");

      return defaultReturn(state);

    case DEAL_SETTINGS_GET.success:
      return multipleObjectReturn(state, ["deal", "guestPermission"], [payload.deal, payload.guestPermission]);

      // ALERTS

    case DEAL_SETTINGS_GET_ALERTS.success:
      return defaultReturn(state, payload.result, "alerts");

      // CLEAR

    case DEAL_SETTINGS_GET_W_SUBKEY.success:
      return fillDictionary(state, payload.deal, "deal", subKey);

      // ATTACHMENTS

    case DEAL_SETTINGS_GET_ATTACHMENTS.success:
      return defaultReturn(state, payload.data, "attachments");

    case DEAL_SETTINGS_PUT_ATTACHMENT.success:
      ToastSuccess("File Successfully Updated");

      return defaultReturn(state);

    case DEAL_SETTINGS_POST_ATTACHMENT.success:
      ToastSuccess("File Successfully Added");

      return defaultReturn(state);

    case DEAL_SETTINGS_DELETE_ATTACHMENT.success:
      ToastSuccess("File Successfully Deleted");

      return state;

      // NOTES

    case DEAL_SETTINGS_GET_NOTES.success:
      return defaultReturn(state, payload.data, "notes");

    case DEAL_SETTINGS_POST_NOTE.success:
      ToastSuccess("Note Successfully Added");

      return defaultReturn(state);

    case DEAL_SETTINGS_PUT_NOTE.success:
      ToastSuccess("Note Successfully Updated");

      return defaultReturn(state);

    case DEAL_SETTINGS_DELETE_NOTE.success:
      ToastSuccess("Note Successfully Deleted");

      return state;

    case DEAL_SETTINGS_CANCEL_REFINANCE.success:
      return { ...state };

    case DEAL_SETTINGS_CLOSE_DEAL.success:
      ToastSuccess("Deal Successfully Closed");

      return state;

    case DEAL_SETTINGS_CANCEL_MODIFY_LOANS.success:
      ToastSuccess("Deal Modification Canceled");

      return state;

    case DEAL_SETTINGS_UPDATE_DETAILS.success:
      ToastSuccess("Deal Update Complete");

      return state;
    case DEAL_SETTINGS_UPDATE_DETAILS.failure:
      ToastSuccess("Deal Update Failed");

      return state;
    // DEFAULT
    default:
      return state;
  }
}

// SAGA

export function* dealSettingsSaga() {
  yield takeLatest(DEAL_SETTINGS_GET.value, dealGetSaga);
  yield takeLatest(DEAL_SETTINGS_GET_ALERTS.value, dealGetAlertsSaga);
  yield takeLatest(DEAL_SETTINGS_GET_W_SUBKEY.value, dealGetWithSubkeySaga);
  yield takeLatest(DEAL_SETTINGS_GET_ATTACHMENTS.value, dealGetAttachmentsSaga);
  yield takeLatest(DEAL_SETTINGS_PUT_ATTACHMENT.value, dealPutAttachmentSaga);
  yield takeLatest(DEAL_SETTINGS_POST_ATTACHMENT.value, dealPostAttachmentSaga);
  yield takeLatest(DEAL_SETTINGS_DELETE_ATTACHMENT.value, dealDeleteAttachmentSaga);
  yield takeLatest(DEAL_SETTINGS_GET_NOTES.value, dealGetNotesSaga);
  yield takeLatest(DEAL_SETTINGS_PUT_NOTE.value, dealPutNoteSaga);
  yield takeLatest(DEAL_SETTINGS_POST_NOTE.value, dealPostNoteSaga);
  yield takeLatest(DEAL_SETTINGS_DELETE_NOTE.value, dealDeleteNoteSaga);
  yield takeLatest(DEAL_SETTINGS_CANCEL_REFINANCE.value, cancelDealRefinanceSaga);
  yield takeLatest(DEAL_SETTINGS_REVIVE_DEAL.value, reviveDealSaga);
  yield takeLatest(DEAL_SETTINGS_KILL_DEAL.value, killDealSaga);
  yield takeLatest(DEAL_SETTINGS_CHANGE_STAGE.value, changeDealStageSaga);
  yield takeLatest(DEAL_SETTINGS_CLOSE_DEAL.value, closeDealSaga);
  yield takeLatest(DEAL_SETTINGS_CANCEL_MODIFY_LOANS.value, cancelModifyLoansSaga);
  yield takeLatest(DEAL_SETTINGS_UPDATE_DETAILS.value, updateDealSaga);
}
